import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  standalone: true,
  selector: 'ain-root',
  imports: [RouterOutlet],
  template: '<router-outlet />'
})
export class AppComponent {}
